export default [
    {
        getDemoButton: "https://anima-uploads.s3.amazonaws.com/projects/608c660520169a1bb3180ff5/releases/608c6b94f68e88411d2707bb/img/buttons-orange@2x.svg",
        text7: "Get Demo",
        rectangle520: "https://anima-uploads.s3.amazonaws.com/projects/608c660520169a1bb3180ff5/releases/608c6b94f68e88411d2707bb/img/rectangle-520-1@2x.svg",
    }
]